import { Link } from "react-router-dom";

export interface MoneyHeroData {
  type?: string;
  title: string;
  subText?: string;
  button: string;
  bgImage: string;
  image: string;
  redirectUrl: string;
  theme: string;
  textColor: string;
  imageClass?: string;
}

const MoneyHero = ({ data }: { data: MoneyHeroData }) => {
  return (
    <div className="w-full p-6 bg-white rounded-[12px]">
      {data?.type && <h1 className="text-[32px] font-[600]">{data.type}</h1>}
      <div className="w-full h-[250px] flex justify-between bg-[#090909] rounded-[10px] relative overflow-hidden text-white px-[40px] items-center">
        <img
          src={data.bgImage}
          alt="Invest"
          className="absolute w-[670.3px] left-[50%] -translate-x-[50%] -top-[460px] z-0 pointer-events-none"
        />
        <div className="relative z-5">
          <h1 className="text-[40px] sm:w-[400px] font-[600] leading-[48px]">
            {data.title}
          </h1>
          {data?.subText && (
            <h1 className="text-[22px] sm:w-[400px] font-[600] leading-[48px]">
              {data.subText}
            </h1>
          )}
          <Link to={data.redirectUrl}>
            <button
              className="py-[10px] px-[20px] rounded-full font-bold mt-4 w-fit relative z-2"
              style={{
                backgroundColor: data.theme,
                color: data.textColor,
              }}
            >
              {data.button}
            </button>
          </Link>
        </div>
        <img src={data.image} className={`${data?.imageClass}`}></img>
      </div>
    </div>
  );
};

export default MoneyHero;
